"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XpeditionFileType = void 0;
exports.getXpeditionFileType = getXpeditionFileType;
exports.validateXpeditionFile = validateXpeditionFile;
exports.detectXpeditionProjects = detectXpeditionProjects;
const project_detection_1 = require("../project-detection");
var XpeditionFileType;
(function (XpeditionFileType) {
    XpeditionFileType["Project"] = "xpedition-project";
    XpeditionFileType["Telesis"] = "xpedition-telesis-netlist";
    XpeditionFileType["FlatNet"] = "xpedition-flat-net";
})(XpeditionFileType || (exports.XpeditionFileType = XpeditionFileType = {}));
const EXTENSION_FILE_TYPES = new Map([
    ['.prj', XpeditionFileType.Project],
    ['.tel', XpeditionFileType.Telesis],
    ['.qcv', XpeditionFileType.FlatNet],
]);
function getXpeditionFileType(filename) {
    const lower = filename.toLowerCase();
    const dotIndex = lower.lastIndexOf('.');
    if (dotIndex === -1) {
        return false;
    }
    return EXTENSION_FILE_TYPES.get(lower.slice(dotIndex)) ?? false;
}
function semanticTypeFor(type) {
    switch (type) {
        case XpeditionFileType.Project:
            return 'project';
        case XpeditionFileType.Telesis:
            return 'schematic';
        case XpeditionFileType.FlatNet:
            return 'netlist';
    }
}
function validateXpeditionFile(filename) {
    const type = getXpeditionFileType(filename);
    if (type === false) {
        return { isValid: false, errors: [`Not a recognized Xpedition file: ${filename}`] };
    }
    return {
        isValid: true,
        data: {
            semanticType: semanticTypeFor(type),
            fileFormat: { cadTool: 'xpedition', type },
            referencedFiles: [],
            metadata: {},
        },
    };
}
function detectXpeditionProjects(files, fileDetails) {
    return (0, project_detection_1.detectAnchoredProjects)({
        tool: 'xpedition',
        toolDisplayName: 'Xpedition',
        files,
        fileDetails,
        primaryAnchorMatch: (0, project_detection_1.endsWithExt)('.prj'),
        primaryAnchorLabel: '.prj',
    });
}
//# sourceMappingURL=xpeditionValidation.js.map